<template>

  <v-autocomplete v-model="federationID"
                  label="Federation"
                  :placeholder="placeholder"
                  :items="federations"
                  item-text="name"
                  item-value="id"
                  :clearable="true"
                  :loading="loading"
                  :disabled="isDisabled"
                  hide-no-data="hide-no-data"></v-autocomplete>

</template>

<script>

export default {
  name: 'FederationSelector',
  props: ['sportID', 'currentFederationID'],
  data () {
    return {
      loading: false,
      federations: [],
      federationID: ''
    }
  },
  mounted () {
    if (this.sportID) {
      this.loadFederations()
    }

    if (this.currentFederationID) {
      this.federationID = this.currentFederationID
    }
  },
  methods: {
    loadFederations () {
      if (!this.currentFederationID) {
        this.$emit('federationSelected', '')
      }

      if ((Array.isArray(this.sportID) && this.sportID.length > 0) || (typeof this.sportID === 'string' && this.sportID)) {
        this.loading = true
        this.$store.dispatch('getSportFederations', this.sportID)
          .then(resp => {
            this.federations = resp
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            alert('Error loading federations')
          })
      } else {
        this.clear()
      }
    },
    clear () {
      this.federationID = ''
      this.federations = []
    }
  },
  computed: {
    isDisabled () {
      return this.federations.length === 0
    },
    placeholder () {
      return this.isDisabled ? 'Please select a sport first' : 'Federation'
    }
  },
  watch: {
    'sportID' () {
      this.clear()
      this.loadFederations()
    },
    'federationID' () {
      this.$emit('federationSelected', this.federationID || '')
    },
    'currentFederationID' () {
      if (this.currentFederationID) {
        this.federationID = this.currentFederationID
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/FederationSelector.vue